module.exports = __webpack_public_path__ + "img/grey.62dbd28.svg";